export default function prepareFormData(data) {
    return Object.keys(data).reduce((acc, key) => {
        acc[key] = data[key]?.value ? data[key].value : data[key];
        return acc;
    }, {});
}